import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToolbarComponent} from './toolbar.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {RouterModule} from '@angular/router';
import { UserMenuModule } from './user-menu/user-menu.module';
import { GlobalSearchModule } from './global-search/global-search.module';
import {MatMenuModule} from '@angular/material/menu';
import {ContactUsDialogComponent} from './contact-us-dialog/contact-us-dialog.component';
import {IconsModule} from '../../icons/icons.module';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatDividerModule} from '@angular/material/divider';
import {ErrorModule} from '../../components/error/error.module';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {NotificationsModule} from 'src/app/components/notifications/notifications.module';
import {MatIconModule} from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import {NotificationsComponent} from './notifications/notifications.component';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {BookmarksComponent} from './bookmarks/bookmarks.component';
import { SupportResourcesComponent } from './support-resources/support-resources.component';
import { MatTabsModule } from '@angular/material/tabs';
import { TenantBookmarkComponent } from './tenant-bookmark/tenant-bookmark.component';
import { AboutPortalComponent } from './about-portal/about-portal.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ToolbarComponent,
    ContactUsDialogComponent,
    NotificationsComponent,
    BookmarksComponent,
    TenantBookmarkComponent,
    SupportResourcesComponent,
    AboutPortalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule,
    MatMenuModule,
    IconsModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDividerModule,
    ErrorModule,
    MatSlideToggleModule,
    FormsModule,
    NotificationsModule,
    MatIconModule,
    MatBadgeModule,
    MatToolbarModule,
    MatButtonModule,
    SearchFilterModule,
    MatCardModule,
    MatListModule,
    SidenavHeaderModule,
    MatTabsModule,
    UserMenuModule,
    GlobalSearchModule,
    ClipboardModule,
    MatTooltipModule
  ],
  exports: [
    ToolbarComponent
  ],
})
export class ToolbarModule {
}
